// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function algoliaRetrieve() {
  return http<Record<string, string>>({
    url: "/api/v1/auth/algolia/",
    method: "get",
  })
}
